/** What the workflows split view is showing on the right: a saved workflow, one
 * of its scheduled-day runs (opened from the calendar), or an unsaved create
 * draft in the detail pane. Past runs are never a selection — a run IS a chat,
 * so run rows navigate to `/scribe/chat/projects/[id]` instead. */
export type WorkflowSelection =
  | {
      kind: 'workflow';
      id: string;
      /** Preserve the existing immediate-run handoff for an Explore Play action. */
      autoRun?: boolean;
      /** Bumped on every press of an autoRun affordance. Pressing play again on
       * the routine already open would otherwise be an identical selection —
       * no remount, and the pane's once-per-routine guard swallows the run. */
      runNonce?: number;
      /** Open the Add view and seed its create-routine chat turn. */
      autoAdd?: boolean;
      /** Open the Edit view for the Explore "Make it your own" handoff. */
      autoAdvanced?: boolean;
      /** Owned routine with no prior run: Heidi asks before starting one. */
      firstRun?: boolean;
    }
  | { kind: 'scheduled-run'; id: string; date: string } // date = local YYYY-MM-DD
  /** Blank create draft in the split right pane — no backend row until Create. */
  | { kind: 'create' };

/** Routine id the split-view list pane should stay focused on, if any. */
export function focusedWorkflowIdFromSelection(
  selection: WorkflowSelection | null
): string | null {
  if (!selection) return null;
  if (selection.kind === 'workflow') return selection.id;
  if (selection.kind === 'scheduled-run') return selection.id;
  return null;
}

/**
 * Well-known id/slug of the "Your daily brief" system routine.
 * Not shown in the UI yet (banner removed until the backend ships it); still
 * filtered out of the Explore grid if the list API returns it.
 */
export const DAILY_BRIEF_WORKFLOW_ID = 'sys-daily-brief';
export const DAILY_BRIEF_SLUG = 'daily-brief';
